// extracted by mini-css-extract-plugin
export default {"main":"ContractAdressPanel_main__D9iQ5","motion__cont":"ContractAdressPanel_motion__cont__IKA-t"};